

if (!customElements.get('our-guides') ) {
  class OurGuides extends HTMLElement {
    constructor() {
      super();

      this.state = {
        slider: null,
        desktopSlidesPerView: this.dataset.desktopSlidesPerView,
        tabletSlidesPerView: this.dataset.tabletSlidesPerView,
        mobileSlidesPerView: this.dataset.mobileSlidesPerView
      };

      this.elements = {
        swiper: this.querySelector('.swiper'),
        swiperBtnNext: this.querySelector('.slider-button-next'),
        swiperBtnPrev: this.querySelector('.slider-button-prev')
      };
    }
  
    connectedCallback() {
      this.initSwiper();
    }
  
    disconnectedCallback() {
      this.state.slider.destroy();
    }

    initSwiper() {
      this.state.slider = new Swiper(this.elements.swiper, {
        slidesPerView: +this.state.mobileSlidesPerView,
        spaceBetween: 32,
        loop: false,
        navigation: {
          nextEl: this.elements.swiperBtnNext,
          prevEl: this.elements.swiperBtnPrev,
        },
        breakpoints: {
          768: {
            slidesPerView: +this.state.tabletSlidesPerView,
            spaceBetween: 45,
          },
          1400: {
            slidesPerView: +this.state.desktopSlidesPerView,
            spaceBetween: 60,
          }
        }
      });
    }
  
  }
  customElements.define('our-guides', OurGuides);
}